import { useEffect, useRef } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import history from 'shared/util/routing/history'

export default function PendingUpdateHandler(): JSX.Element {
  const { 'apply-updates-over-navigation': applyUpdatesOverNavigation } = useFlags()
  const unblockRef = useRef<(() => void) | null>(null)

  useEffect(() => {
    if (!applyUpdatesOverNavigation) return

    const onUpdateReady = () => {
      console.log('[PendingUpdateHandler] New version available — update will apply on next navigation')
      if (unblockRef.current) return

      unblockRef.current = history.block((nextLocation) => {
        console.log('[PendingUpdateHandler] Navigation detected, applying update:', history.createHref(nextLocation))
        window.location.assign(history.createHref(nextLocation))
        return false
      })
    }

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.metaKey && e.key === 'U') {
        console.log('[PendingUpdateHandler] Simulating UPDATE_READY event')
        window.dispatchEvent(new Event('UPDATE_READY'))
      }
    }

    window.addEventListener('UPDATE_READY', onUpdateReady)
    window.addEventListener('keydown', onKeyDown)

    return () => {
      window.removeEventListener('UPDATE_READY', onUpdateReady)
      window.removeEventListener('keydown', onKeyDown)
      unblockRef.current?.()
      unblockRef.current = null
    }
  }, [applyUpdatesOverNavigation])

  return null
}
